import type { ClientRole } from '@/types/user';

// Mirrors Sturm.Domain.Enums.ClientRole. The backend is the only source of truth for access;
// this exists so the UI can hide what a call would refuse anyway.
const ORDER: Record<ClientRole, number> = {
  external: 0,
  internal: 1,
  manager: 2,
  admin: 3,
};

export function hasClientRole(role: unknown): role is ClientRole {
  return typeof role === 'string' && role in ORDER;
}

export function hasAtLeast(role: ClientRole | null | undefined, minimum: ClientRole): boolean {
  if (!hasClientRole(role)) {
    return false;
  }

  return ORDER[role] >= ORDER[minimum];
}

export const CLIENT_ROLES: readonly ClientRole[] = ['external', 'internal', 'manager', 'admin'];
